/**
 * Simple unicode-aware version of String.prototype.split e.g. `'foo'.split('')`.
 *
 * Not ready for all browsers. Only considers splitting on empty string.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Segmenter
 * https://caniuse.com/mdn-javascript_builtins_intl_segmenter
 *
 */
// eslint-disable-next-line @typescript-eslint/ban-types
export const unicodeStringSplit = (input: string) =>
    'Segmenter' in Intl ? [...new Intl.Segmenter().segment(input)].map((x) => x.segment) : input.split('') || []
